/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { When } from "react-if";
import { Link } from "react-router-dom";
import { FlexContainer, Sidebar, Text } from "@nordcloud/gnui";
import { INotificationUI } from "~/models";

type Props = {
  notification: INotificationUI;
  isOpen: boolean;
  onClose: () => void;
  setIsSidebarMainOpen?: (index: boolean) => void;
};

export function NotificationDetails({
  notification,
  isOpen,
  setIsSidebarMainOpen,
  onClose,
}: Props) {
  return (
    <Sidebar title={notification.title} isOpen={isOpen} onClick={onClose}>
      <Text>{notification.description}</Text>
      <FlexContainer justifyContent="center">
        <When condition={notification.targetView}>
          <Link
            to={notification.targetView ?? window.location.pathname}
            onClick={() => {
              setIsSidebarMainOpen?.(false);
            }}
          >
            more
          </Link>
        </When>
      </FlexContainer>
    </Sidebar>
  );
}
